import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie11'; // For IE 11 support
// import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { countReducer } from './redux/reducer';
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
// import { from } from 'core-js/fn/array';
const middleware = [thunk]
let store = createStore(countReducer,composeWithDevTools(applyMiddleware(...middleware)));


const RootApp = () => (
    <Provider store={store}>
      <App />
    </Provider>
  );

ReactDOM.render(<RootApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
